var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41.000000, -982.000000)",
    fill: "#24637D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.140625,990.328125 C51.140625,990.536459 51.0677091,990.713541 50.921875,990.859375 L49.859375,991.921875 C49.7135409,992.067709 49.5364594,992.140625 49.328125,992.140625 C49.1197906,992.140625 48.9427091,992.067709 48.796875,991.921875 L46.5,989.625 L44.203125,991.921875 C44.0572909,992.067709 43.8802094,992.140625 43.671875,992.140625 C43.4635406,992.140625 43.2864591,992.067709 43.140625,991.921875 L42.078125,990.859375 C41.9322909,990.713541 41.859375,990.536459 41.859375,990.328125 C41.859375,990.119791 41.9322909,989.942709 42.078125,989.796875 L44.375,987.5 L42.078125,985.203125 C41.9322909,985.057291 41.859375,984.880209 41.859375,984.671875 C41.859375,984.463541 41.9322909,984.286459 42.078125,984.140625 L43.140625,983.078125 C43.2864591,982.932291 43.4635406,982.859375 43.671875,982.859375 C43.8802094,982.859375 44.0572909,982.932291 44.203125,983.078125 L46.5,985.375 L48.796875,983.078125 C48.9427091,982.932291 49.1197906,982.859375 49.328125,982.859375 C49.5364594,982.859375 49.7135409,982.932291 49.859375,983.078125 L50.921875,984.140625 C51.0677091,984.286459 51.140625,984.463541 51.140625,984.671875 C51.140625,984.880209 51.0677091,985.057291 50.921875,985.203125 L48.625,987.5 L50.921875,989.796875 C51.0677091,989.942709 51.140625,990.119791 51.140625,990.328125 L51.140625,990.328125 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelX);
export default __webpack_public_path__ + "static/media/cancel-x.4adf12f066b2c5212cda12227a7daaf1.svg";
export { ForwardRef as ReactComponent };